export enum PersonalizedTakeawaysSectionId {
  AT_A_GLANCE = 'takeaways-section-at-a-glance',
  IN_THE_NUMBERS = 'takeaways-section-in-the-numbers',
  COURSE_HIGHLIGHTS = 'takeaways-section-course-highlights',
  YOUR_STRENGTHS = 'takeaways-section-your-strengths',
  YOUR_NEXT_LEVEL = 'takeaways-section-your-next-level',
  KEEP_LEARNING = 'takeaways-section-keep-learning',
  CONGRATULATIONS = 'takeaways-section-congratulations',
}

export const PERSONALIZED_TAKEAWAYS_SCROLL_EVENT = 'personalized-takeaways:scroll';
